<template>
    <div>
        <FilterTable 
          :resource_name="resource_name"
          :title="title"
          :field_definitions="field_definitions"
          :filters="filters"
          :action_buttons="action_buttons"
          :row_actions="row_actions"
          :translate_to_display_data="translate_to_display_data"
          :route_root="route_root"
          :handle_row_action="handle_row_action"
          :full_text_search="false"
          :handle_action_button_click="handle_action_button_click"
          :update_flag="filter_table_update_flag"
        />
    </div>
</template>

<script>
import FilterTable from '@/components/backstage/FilterTable/FilterTable.vue'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'

export default {
    mixins: [breadcrumbMixin],
    components: {
      FilterTable,
    },
    data() {
      return {
        resource_name: 'system-log',
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/system-log',
        title: '系統日誌',
        route_root: 'system-management/system-log',
        field_definitions: [
          {
            display: {
              name: '姓名',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'username',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '帳號',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'email',
              data_type: 'string',
            }
          },
          {
            display: {
              name: 'IP',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'ip_address',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '時間',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'created_time',
              data_type: 'datetime',
            }
          },
          {
            display: {
              name: '動作',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'action_description',
              data_type: 'string',
            }
          },
        ],
        filters: {
          '選擇時間區間': {
            paramName: 'created_time',
            value: {
              'start': null,
              'end': null
            },
            options: {
                type: 'time-range',
            }
          },
        },
        action_buttons: {
        },
        row_actions: {
        },
        filter_table_update_flag: 0
      }
    },
    methods: {
      translate_to_display_data(data) {
        console.log('translate_to_display_data')

        let types = {}
        this.field_definitions.forEach(
          function (field) {
            types[field['source']['key']] = field['source']['data_type']
          })

        let translated_data = data
        
        for (let key in data) {
          if (types[key] === 'datetime' && data[key]) {
            translated_data[key] = data[key].date.slice(0,-7)
          }
        }
        
        return translated_data
      },
      handle_row_action (action, index, row) {
        console.log('DetailPageDigitalObjectTab: action:' + action + ', index: ' + index + ', row: ', row)

        switch(action){ 
          default:
            break
        }
      },
      handle_action_button_click (action) {
        console.log('DetailPageDigitalObjectTab: action button clicked: ', action)

        switch(action){
          default:
            break
        }
      },
      handle_do_update () {
        this.filter_table_update_flag += 1
      },
    }
  };
</script>

<style>
</style>
